/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionSettleDetailOrderItemVo } from './CommissionSettleDetailOrderItemVo';
import {
    CommissionSettleDetailOrderItemVoFromJSON,
    CommissionSettleDetailOrderItemVoFromJSONTyped,
    CommissionSettleDetailOrderItemVoToJSON,
    CommissionSettleDetailOrderItemVoToJSONTyped,
} from './CommissionSettleDetailOrderItemVo';
import type { CommissionRateServiceVo } from './CommissionRateServiceVo';
import {
    CommissionRateServiceVoFromJSON,
    CommissionRateServiceVoFromJSONTyped,
    CommissionRateServiceVoToJSON,
    CommissionRateServiceVoToJSONTyped,
} from './CommissionRateServiceVo';

/**
 * 
 * @export
 * @interface CommissionSettleDetailRespVo
 */
export interface CommissionSettleDetailRespVo {
    /**
     * 合作会员id
     * @type {number}
     * @memberof CommissionSettleDetailRespVo
     */
    userId?: number;
    /**
     * 是否已结清（当月全部佣金记录均已结算为true）
     * @type {boolean}
     * @memberof CommissionSettleDetailRespVo
     */
    settled?: boolean;
    /**
     * 表头附加服务列（billType=3账单可选的附加服务，全部仓库并集）
     * @type {Array<CommissionRateServiceVo>}
     * @memberof CommissionSettleDetailRespVo
     */
    serviceColumns?: Array<CommissionRateServiceVo>;
    /**
     * 订单明细行列表，按出库日期升序
     * @type {Array<CommissionSettleDetailOrderItemVo>}
     * @memberof CommissionSettleDetailRespVo
     */
    orders?: Array<CommissionSettleDetailOrderItemVo>;
    /**
     * 合计--附加服务金额（小计列合计）
     * @type {number}
     * @memberof CommissionSettleDetailRespVo
     */
    totalServiceAmount?: number;
    /**
     * 合计--分成金额（业绩列合计）
     * @type {number}
     * @memberof CommissionSettleDetailRespVo
     */
    totalCommissionAmount?: number;
    /**
     * 开户银行
     * @type {string}
     * @memberof CommissionSettleDetailRespVo
     */
    bankName?: string;
    /**
     * 银行账号
     * @type {string}
     * @memberof CommissionSettleDetailRespVo
     */
    bankAccount?: string;
    /**
     * 开户名
     * @type {string}
     * @memberof CommissionSettleDetailRespVo
     */
    accountHolder?: string;
    /**
     * 结算文件名（已结清时返回）
     * @type {string}
     * @memberof CommissionSettleDetailRespVo
     */
    fileName?: string;
    /**
     * 结算文件路径（已结清时返回）
     * @type {string}
     * @memberof CommissionSettleDetailRespVo
     */
    filePath?: string;
}

/**
 * Check if a given object implements the CommissionSettleDetailRespVo interface.
 */
export function instanceOfCommissionSettleDetailRespVo(value: object): value is CommissionSettleDetailRespVo {
    return true;
}

export function CommissionSettleDetailRespVoFromJSON(json: any): CommissionSettleDetailRespVo {
    return CommissionSettleDetailRespVoFromJSONTyped(json, false);
}

export function CommissionSettleDetailRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionSettleDetailRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'settled': json['settled'] == null ? undefined : json['settled'],
        'serviceColumns': json['serviceColumns'] == null ? undefined : ((json['serviceColumns'] as Array<any>).map(CommissionRateServiceVoFromJSON)),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(CommissionSettleDetailOrderItemVoFromJSON)),
        'totalServiceAmount': json['totalServiceAmount'] == null ? undefined : json['totalServiceAmount'],
        'totalCommissionAmount': json['totalCommissionAmount'] == null ? undefined : json['totalCommissionAmount'],
        'bankName': json['bankName'] == null ? undefined : json['bankName'],
        'bankAccount': json['bankAccount'] == null ? undefined : json['bankAccount'],
        'accountHolder': json['accountHolder'] == null ? undefined : json['accountHolder'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'filePath': json['filePath'] == null ? undefined : json['filePath'],
    };
}

export function CommissionSettleDetailRespVoToJSON(json: any): CommissionSettleDetailRespVo {
    return CommissionSettleDetailRespVoToJSONTyped(json, false);
}

export function CommissionSettleDetailRespVoToJSONTyped(value?: CommissionSettleDetailRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'settled': value['settled'],
        'serviceColumns': value['serviceColumns'] == null ? undefined : ((value['serviceColumns'] as Array<any>).map(CommissionRateServiceVoToJSON)),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(CommissionSettleDetailOrderItemVoToJSON)),
        'totalServiceAmount': value['totalServiceAmount'],
        'totalCommissionAmount': value['totalCommissionAmount'],
        'bankName': value['bankName'],
        'bankAccount': value['bankAccount'],
        'accountHolder': value['accountHolder'],
        'fileName': value['fileName'],
        'filePath': value['filePath'],
    };
}

